import React, { useEffect, useMemo } from "react";
import styles from '../styles/orderFiled.module.scss';
import Select from "@/wmCompoments/select";
import { useOrderList } from "../hooks/api";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface Props {
    name: string
    typeName: string
}
const OrderFiled = (props: Props) => {
    const { t } = useTranslation('feedback')
    
    const { name , typeName} = props ?? {}

    const {
        register,
        setValue,
        watch,
        trigger
    } = useFormContext();

    // 注册字段及校验规则
    useEffect(() => {
        register(name);
    }, [register, name]);

    const value = watch(name);

    const valueType = watch(typeName)

    const { list } = useOrderList(valueType?.category)

    const options = useMemo(() => {
        if (list) {
            return list?.map((v) => {
                return {
                    ...v,
                    label: v.title,
                    value: v.id
                }
            })
        }
        return []
    }, [list])

    if (![1, 2, 3].includes(valueType?.category)) {
        return null
    }

    return <div className={styles.warpper}>
        <div>
            <span>{t('relatedOrder')}</span>
        </div>
        <div>
            <Select
                value={value?.value}
                options={options}
                className={styles.select}
                onChange={(v, o) => {
                    setValue(name, o)
                    trigger(name)
                }}
                showSearch={true}
                searchPlaceholder={t('enterRelatedOrder')}
                placeholder={t('selectOrderType')}
            />
        </div>
    </div>
}

export default OrderFiled